export enum WeekOrMonthTabsEnum {
    WeekTab = 'WeekTab',
    MonthTab = 'MonthTab',
  }
  